import { render } from "./Advantages.vue?vue&type=template&id=b37de446&scoped=true"
import script from "./Advantages.vue?vue&type=script&lang=js"
export * from "./Advantages.vue?vue&type=script&lang=js"

import "./Advantages.vue?vue&type=style&index=0&id=b37de446&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b37de446"

export default script